import React from "react";

interface StatusBadgeProps {
  status: string;
}

const statusConfig: {
  [key: string]: { color: string; icon: string; bgColor: string };
} = {
  Pendiente: {
    color: "#f59e0b",
    icon: "fa-clock",
    bgColor: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
  },
  Resuelto: {
    color: "#059669",
    icon: "fa-check-circle",
    bgColor: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
  },
  "No resuelto": {
    color: "#dc2626",
    icon: "fa-times-circle",
    bgColor: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
  },
  Cumplio: {
    color: "#059669",
    icon: "fa-check",
    bgColor: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
  },
  "No llego": {
    color: "#dc2626",
    icon: "fa-user-slash",
    bgColor: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
  },
  "Llego tarde": {
    color: "#f59e0b",
    icon: "fa-clock",
    bgColor: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
  },
  "Salio tarde": {
    color: "#f59e0b",
    icon: "fa-clock",
    bgColor: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
  },
  "Descanso trabajado": {
    color: "#2563eb",
    icon: "fa-calendar-check",
    bgColor: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
  },
  "No procede": {
    color: "#6b7280",
    icon: "fa-ban",
    bgColor: "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status] || {
    color: "#6b7280",
    icon: "fa-circle",
    bgColor: "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
  };

  return (
    <span
      style={{
        ...styles.badge,
        background: config.bgColor,
        color: config.color,
      }}
    >
      <i className={`fas ${config.icon}`} style={styles.icon}></i>
      {status}
    </span>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  badge: {
    padding: "0.5rem 0.75rem",
    borderRadius: "8px",
    fontSize: "0.75rem",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    gap: "0.375rem",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  icon: {
    fontSize: "0.7rem",
  },
};

export default StatusBadge;
